/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
// ^ Disabling the above rule as some svg names like 'tomato' are variable names, not color names ^^
import { defineMessage } from 'react-intl-next';

import { type MessageDescriptor } from '@canvas/intl';

import apple from './emojis/apple.svg';
import avocado from './emojis/avocado.svg';
import badger from './emojis/badger.svg';
import bat from './emojis/bat.svg';
import bear from './emojis/bear.svg';
import beaver from './emojis/beaver.svg';
import bee from './emojis/bee.svg';
import bison from './emojis/bison.svg';
import blossom from './emojis/blossom.svg';
import blowfish from './emojis/blowfish.svg';
import blueberries from './emojis/blueberries.svg';
import boar from './emojis/boar.svg';
import broccoli from './emojis/broccoli.svg';
import butterfly from './emojis/butterfly.svg';
import cactus from './emojis/cactus.svg';
import camel from './emojis/camel.svg';
import candy from './emojis/candy.svg';
import capsicum from './emojis/capsicum.svg';
import carrot from './emojis/carrot.svg';
import cat from './emojis/cat.svg';
import caterpiller from './emojis/caterpiller.svg';
import cherry from './emojis/cherry.svg';
import chili from './emojis/chili.svg';
import clover from './emojis/clover.svg';
import coconut from './emojis/coconut.svg';
import cookie from './emojis/cookie.svg';
import corn from './emojis/corn.svg';
import cow from './emojis/cow.svg';
import crab from './emojis/crab.svg';
import crocodile from './emojis/crocodile.svg';
import deer from './emojis/deer.svg';
import dinosaur from './emojis/dinosaur.svg';
import dodo from './emojis/dodo.svg';
import dog from './emojis/dog.svg';
import dolphin from './emojis/dolphin.svg';
import donut from './emojis/donut.svg';
import dragon from './emojis/dragon.svg';
import duck from './emojis/duck.svg';
import elephant from './emojis/elephant.svg';
import fish from './emojis/fish.svg';
import flamingo from './emojis/flamingo.svg';
import fox from './emojis/fox.svg';
import frog from './emojis/frog.svg';
import giraffe from './emojis/giraffe.svg';
import gorilla from './emojis/gorilla.svg';
import grape from './emojis/grapes.svg';
import hedgehog from './emojis/hedgehog.svg';
import hippo from './emojis/hippo.svg';
import kangaroo from './emojis/kangaroo.svg';
import kiwi from './emojis/kiwi.svg';
import koala from './emojis/koala.svg';
import lemon from './emojis/lemon.svg';
import lettuce from './emojis/lettuce.svg';
import lion from './emojis/lion.svg';
import lizard from './emojis/lizard.svg';
import llama from './emojis/llama.svg';
import lobster from './emojis/lobster.svg';
import mango from './emojis/mango.svg';
import melon from './emojis/melon.svg';
import monkey from './emojis/monkey.svg';
import mouse from './emojis/mouse.svg';
import octopus from './emojis/octopus.svg';
import olive from './emojis/olive.svg';
import orange from './emojis/orange.svg';
import orangutan from './emojis/orangutan.svg';
import otter from './emojis/otter.svg';
import owl from './emojis/owl.svg';
import ox from './emojis/ox.svg';
import oyster from './emojis/oyster.svg';
import panda from './emojis/panda.svg';
import parrot from './emojis/parrot.svg';
import peacock from './emojis/peacock.svg';
import pear from './emojis/pear.svg';
import penguin from './emojis/penguin.svg';
import pig from './emojis/pig.svg';
import pineapple from './emojis/pineapple.svg';
import poodle from './emojis/poodle.svg';
import rabbit from './emojis/rabbit.svg';
import raccoon from './emojis/raccoon.svg';
import rhino from './emojis/rhino.svg';
import robot from './emojis/robot.svg';
import rose from './emojis/rose.svg';
import seal from './emojis/seal.svg';
import seedling from './emojis/seedling.svg';
import shark from './emojis/shark.svg';
import shrimp from './emojis/shrimp.svg';
import skunk from './emojis/skunk.svg';
import sloth from './emojis/sloth.svg';
import snail from './emojis/snail.svg';
import snake from './emojis/snake.svg';
import snowman from './emojis/snowman.svg';
import squid from './emojis/squid.svg';
import squirrel from './emojis/squirrel.svg';
import strawberry from './emojis/strawberry.svg';
import sunflower from './emojis/sunflower.svg';
import trex from './emojis/t-rex.svg';
import tiger from './emojis/tiger.svg';
import tomato from './emojis/tomato.svg';
import tree from './emojis/tree.svg';
import tropicalFish from './emojis/tropical-fish.svg';
import turkey from './emojis/turkey.svg';
import turtle from './emojis/turtle.svg';
import watermelon from './emojis/watermelon.svg';
import whale from './emojis/whale.svg';
import wolf from './emojis/wolf.svg';

/**
 * An anonymous asset contains both the avatar svg and the names for the anonymous user if they are
 * the current user or a collaborator.
 */
export type AnonymousAsset = {
  // The name of anonymous collaborators, eg "Anonymous Bear"
  collaboratorName: MessageDescriptor;
  // The name for when the current user is anonymous, eg "Anonymous Bear (You)"
  yourName: MessageDescriptor;
  emojiSvg: string;
};

export const anonymousAssets: AnonymousAsset[] = [
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.bear',
      defaultMessage: 'Anonymous Bear',
      description: 'The nickname for an anonymous user with a bear emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.bear-you',
      defaultMessage: 'Anonymous Bear (You)',
      description:
        'The nickname for when the current user is anonymous, with a bear emoji',
    }),
    emojiSvg: bear,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.octopus',
      defaultMessage: 'Anonymous Octopus',
      description: 'The nickname for an anonymous user with a octopus emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.octopus-you',
      defaultMessage: 'Anonymous Octopus (You)',
      description:
        'The nickname for when the current user is anonymous, with a octopus emoji',
    }),
    emojiSvg: octopus,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.koala',
      defaultMessage: 'Anonymous Koala',
      description: 'The nickname for an anonymous user with a koala emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.koala-you',
      defaultMessage: 'Anonymous Koala (You)',
      description:
        'The nickname for when the current user is anonymous, with a koala emoji',
    }),
    emojiSvg: koala,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.monkey',
      defaultMessage: 'Anonymous Monkey',
      description: 'The nickname for an anonymous user with a monkey emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.monkey-you',
      defaultMessage: 'Anonymous Monkey (You)',
      description:
        'The nickname for when the current user is anonymous, with a monkey emoji',
    }),
    emojiSvg: monkey,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.chimp',
      defaultMessage: 'Anonymous Chimp',
      description: 'The nickname for an anonymous user with a monkey emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.chimp-you',
      defaultMessage: 'Anonymous Chimp (You)',
      description:
        'The nickname for when the current user is anonymous, with a monkey emoji',
    }),
    emojiSvg: monkey,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.macaque',
      defaultMessage: 'Anonymous Macaque',
      description: 'The nickname for an anonymous user with a monkey emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.macaque-you',
      defaultMessage: 'Anonymous Macaque (You)',
      description:
        'The nickname for when the current user is anonymous, with a monkey emoji',
    }),
    emojiSvg: monkey,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.chimpanzee',
      defaultMessage: 'Anonymous Chimpanzee',
      description: 'The nickname for an anonymous user with a monkey emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.chimpanzee-you',
      defaultMessage: 'Anonymous Chimpanzee (You)',
      description:
        'The nickname for when the current user is anonymous, with a monkey emoji',
    }),
    emojiSvg: monkey,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.butterfly',
      defaultMessage: 'Anonymous Butterfly',
      description: 'The nickname for an anonymous user with a butterfly emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.butterfly-you',
      defaultMessage: 'Anonymous Butterfly (You)',
      description:
        'The nickname for when the current user is anonymous, with a butterfly emoji',
    }),
    emojiSvg: butterfly,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.bug',
      defaultMessage: 'Anonymous Bug',
      description:
        'The nickname for an anonymous user with a butterfly emoji. Bug referring to the insect',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.bug-you',
      defaultMessage: 'Anonymous Bug (You)',
      description:
        'The nickname for when the current user is anonymous, with a butterfly emoji. Bug referring to the insect',
    }),
    emojiSvg: butterfly,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.orangutan',
      defaultMessage: 'Anonymous Orangutan',
      description: 'The nickname for an anonymous user with an orangutan emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.orangutan-you',
      defaultMessage: 'Anonymous Orangutan (You)',
      description:
        'The nickname for when the current user is anonymous, with an orangutan emoji',
    }),
    emojiSvg: orangutan,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.ape',
      defaultMessage: 'Anonymous Ape',
      description: 'The nickname for an anonymous user with an orangutan emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.ape-you',
      defaultMessage: 'Anonymous Ape (You)',
      description:
        'The nickname for when the current user is anonymous, with an orangutan emoji',
    }),
    emojiSvg: orangutan,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.baboon',
      defaultMessage: 'Anonymous Baboon',
      description: 'The nickname for an anonymous user with an orangutan emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.baboon-you',
      defaultMessage: 'Anonymous Baboon (You)',
      description:
        'The nickname for when the current user is anonymous, with an orangutan emoji',
    }),
    emojiSvg: orangutan,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.owl',
      defaultMessage: 'Anonymous Owl',
      description: 'The nickname for an anonymous user with an owl emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.owl-you',
      defaultMessage: 'Anonymous Owl (You)',
      description:
        'The nickname for when the current user is anonymous, with an owl emoji',
    }),
    emojiSvg: owl,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.bird',
      defaultMessage: 'Anonymous Bird',
      description: 'The nickname for an anonymous user with an owl emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.bird-you',
      defaultMessage: 'Anonymous Bird (You)',
      description:
        'The nickname for when the current user is anonymous, with an owl emoji',
    }),
    emojiSvg: owl,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.hedgehog',
      defaultMessage: 'Anonymous Hedgehog',
      description: 'The nickname for an anonymous user with a hedgehog emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.hedgehog-you',
      defaultMessage: 'Anonymous Hedgehog (You)',
      description:
        'The nickname for when the current user is anonymous, with a hedgehog emoji',
    }),
    emojiSvg: hedgehog,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.tiger',
      defaultMessage: 'Anonymous Tiger',
      description: 'The nickname for an anonymous user with a tiger emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.tiger-you',
      defaultMessage: 'Anonymous Tiger (You)',
      description:
        'The nickname for when the current user is anonymous, with a tiger emoji',
    }),
    emojiSvg: tiger,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.leopard',
      defaultMessage: 'Anonymous Leopard',
      description: 'The nickname for an anonymous user with a tiger emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.leopard-you',
      defaultMessage: 'Anonymous Leopard (You)',
      description:
        'The nickname for when the current user is anonymous, with a tiger emoji',
    }),
    emojiSvg: tiger,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.sloth',
      defaultMessage: 'Anonymous Sloth',
      description: 'The nickname for an anonymous user with a sloth emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.sloth-you',
      defaultMessage: 'Anonymous Sloth (You)',
      description:
        'The nickname for when the current user is anonymous, with a sloth emoji',
    }),
    emojiSvg: sloth,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.deer',
      defaultMessage: 'Anonymous Deer',
      description: 'The nickname for an anonymous user with a deer emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.deer-you',
      defaultMessage: 'Anonymous Deer (You)',
      description:
        'The nickname for when the current user is anonymous, with a deer emoji',
    }),
    emojiSvg: deer,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.elk',
      defaultMessage: 'Anonymous Elk',
      description: 'The nickname for an anonymous user with a deer emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.elk-you',
      defaultMessage: 'Anonymous Elk (You)',
      description:
        'The nickname for when the current user is anonymous, with a deer emoji',
    }),
    emojiSvg: deer,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.robot',
      defaultMessage: 'Anonymous Robot',
      description: 'The nickname for an anonymous user with a robot emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.robot-you',
      defaultMessage: 'Anonymous Robot (You)',
      description:
        'The nickname for when the current user is anonymous, with a robot emoji',
    }),
    emojiSvg: robot,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.panda',
      defaultMessage: 'Anonymous Panda',
      description: 'The nickname for an anonymous user with a panda emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.panda-you',
      defaultMessage: 'Anonymous Panda (You)',
      description:
        'The nickname for when the current user is anonymous, with a panda emoji',
    }),
    emojiSvg: panda,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.cat',
      defaultMessage: 'Anonymous Cat',
      description: 'The nickname for an anonymous user with a cat emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.cat-you',
      defaultMessage: 'Anonymous Cat (You)',
      description:
        'The nickname for when the current user is anonymous, with a cat emoji',
    }),
    emojiSvg: cat,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.kitten',
      defaultMessage: 'Anonymous Kitten',
      description: 'The nickname for an anonymous user with a cat emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.kitten-you',
      defaultMessage: 'Anonymous Kitten (You)',
      description:
        'The nickname for when the current user is anonymous, with a cat emoji',
    }),
    emojiSvg: cat,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.squid',
      defaultMessage: 'Anonymous Squid',
      description: 'The nickname for an anonymous user with a squid emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.squid-you',
      defaultMessage: 'Anonymous Squid (You)',
      description:
        'The nickname for when the current user is anonymous, with a squid emoji',
    }),
    emojiSvg: squid,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.bee',
      defaultMessage: 'Anonymous Bee',
      description: 'The nickname for an anonymous user with a bee emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.bee-you',
      defaultMessage: 'Anonymous Bee (You)',
      description:
        'The nickname for when the current user is anonymous, with a bee emoji',
    }),
    emojiSvg: bee,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.wasp',
      defaultMessage: 'Anonymous Wasp',
      description: 'The nickname for an anonymous user with a bee emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.wasp-you',
      defaultMessage: 'Anonymous Wasp (You)',
      description:
        'The nickname for when the current user is anonymous, with a bee emoji',
    }),
    emojiSvg: bee,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.cow',
      defaultMessage: 'Anonymous Cow',
      description: 'The nickname for an anonymous user with a cow emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.cow-you',
      defaultMessage: 'Anonymous Cow (You)',
      description:
        'The nickname for when the current user is anonymous, with a cow emoji',
    }),
    emojiSvg: cow,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.bull',
      defaultMessage: 'Anonymous Bull',
      description: 'The nickname for an anonymous user with a cow emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.bull-you',
      defaultMessage: 'Anonymous Bull (You)',
      description:
        'The nickname for when the current user is anonymous, with a cow emoji',
    }),
    emojiSvg: cow,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.racoon',
      defaultMessage: 'Anonymous Racoon',
      description: 'The nickname for an anonymous user with a racoon emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.racoon-you',
      defaultMessage: 'Anonymous Racoon (You)',
      description:
        'The nickname for when the current user is anonymous, with a racoon emoji',
    }),
    emojiSvg: raccoon,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.fox',
      defaultMessage: 'Anonymous Fox',
      description: 'The nickname for an anonymous user with a fox emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.fox-you',
      defaultMessage: 'Anonymous Fox (You)',
      description:
        'The nickname for when the current user is anonymous, with a fox emoji',
    }),
    emojiSvg: fox,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.dolphin',
      defaultMessage: 'Anonymous Dolphin',
      description: 'The nickname for an anonymous user with a dolphin emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.dolphin-you',
      defaultMessage: 'Anonymous Dolphin (You)',
      description:
        'The nickname for when the current user is anonymous, with a dolphin emoji',
    }),
    emojiSvg: dolphin,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.pig',
      defaultMessage: 'Anonymous Pig',
      description: 'The nickname for an anonymous user with a pig emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.pig-you',
      defaultMessage: 'Anonymous Pig (You)',
      description:
        'The nickname for when the current user is anonymous, with a pig emoji',
    }),
    emojiSvg: pig,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.lion',
      defaultMessage: 'Anonymous Lion',
      description: 'The nickname for an anonymous user with a lion emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.lion-you',
      defaultMessage: 'Anonymous Lion (You)',
      description:
        'The nickname for when the current user is anonymous, with a lion emoji',
    }),
    emojiSvg: lion,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.wolf',
      defaultMessage: 'Anonymous Wolf',
      description: 'The nickname for an anonymous user with a wolf emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.wolf-you',
      defaultMessage: 'Anonymous Wolf (You)',
      description:
        'The nickname for when the current user is anonymous, with a wolf emoji',
    }),
    emojiSvg: wolf,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.elephant',
      defaultMessage: 'Anonymous Elephant',
      description: 'The nickname for an anonymous user with an elephant emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.elephant-you',
      defaultMessage: 'Anonymous Elephant (You)',
      description:
        'The nickname for when the current user is anonymous, with an elephant emoji',
    }),
    emojiSvg: elephant,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.whale',
      defaultMessage: 'Anonymous Whale',
      description: 'The nickname for an anonymous user with a whale emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.whale-you',
      defaultMessage: 'Anonymous Whale (You)',
      description:
        'The nickname for when the current user is anonymous, with a whale emoji',
    }),
    emojiSvg: whale,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.bat',
      defaultMessage: 'Anonymous Bat',
      description: 'The nickname for an anonymous user with a bat emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.bat-you',
      defaultMessage: 'Anonymous Bat (You)',
      description:
        'The nickname for when the current user is anonymous, with a bat emoji',
    }),
    emojiSvg: bat,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.crab',
      defaultMessage: 'Anonymous Crab',
      description: 'The nickname for an anonymous user with a crab emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.crab-you',
      defaultMessage: 'Anonymous Crab (You)',
      description:
        'The nickname for when the current user is anonymous, with a crab emoji',
    }),
    emojiSvg: crab,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.mouse',
      defaultMessage: 'Anonymous Mouse',
      description: 'The nickname for an anonymous user with a mouse emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.mouse-you',
      defaultMessage: 'Anonymous Mouse (You)',
      description:
        'The nickname for when the current user is anonymous, with a mouse emoji',
    }),
    emojiSvg: mouse,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.rat',
      defaultMessage: 'Anonymous Rat',
      description: 'The nickname for an anonymous user with a mouse emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.rat-you',
      defaultMessage: 'Anonymous Rat (You)',
      description:
        'The nickname for when the current user is anonymous, with a mouse emoji',
    }),
    emojiSvg: mouse,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.dragon',
      defaultMessage: 'Anonymous Dragon',
      description: 'The nickname for an anonymous user with a dragon emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.dragon-you',
      defaultMessage: 'Anonymous Dragon (You)',
      description:
        'The nickname for when the current user is anonymous, with a dragon emoji',
    }),
    emojiSvg: dragon,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.skunk',
      defaultMessage: 'Anonymous Skunk',
      description: 'The nickname for an anonymous user with a skunk emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.skunk-you',
      defaultMessage: 'Anonymous Skunk (You)',
      description:
        'The nickname for when the current user is anonymous, with a skunk emoji',
    }),
    emojiSvg: skunk,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.trex',
      defaultMessage: 'Anonymous T-rex',
      description: 'The nickname for an anonymous user with a T-rex emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.trex-you',
      defaultMessage: 'Anonymous T-rex (You)',
      description:
        'The nickname for when the current user is anonymous, with a T-rex emoji',
    }),
    emojiSvg: trex,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.dinosaur',
      defaultMessage: 'Anonymous Dinosaur',
      description: 'The nickname for an anonymous user with a dinosaur emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.dinosaur-you',
      defaultMessage: 'Anonymous Dinosaur (You)',
      description:
        'The nickname for when the current user is anonymous, with a dinosaur emoji',
    }),
    emojiSvg: dinosaur,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.dodo',
      defaultMessage: 'Anonymous Dodo',
      description: 'The nickname for an anonymous user with a dodo emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.dodo-you',
      defaultMessage: 'Anonymous Dodo (You)',
      description:
        'The nickname for when the current user is anonymous, with a dodo emoji',
    }),
    emojiSvg: dodo,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.parrot',
      defaultMessage: 'Anonymous Parrot',
      description: 'The nickname for an anonymous user with a parrot emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.parrot-you',
      defaultMessage: 'Anonymous Parrot (You)',
      description:
        'The nickname for when the current user is anonymous, with a parrot emoji',
    }),
    emojiSvg: parrot,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.flamingo',
      defaultMessage: 'Anonymous Flamingo',
      description: 'The nickname for an anonymous user with a flamingo emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.flamingo-you',
      defaultMessage: 'Anonymous Flamingo (You)',
      description:
        'The nickname for when the current user is anonymous, with a flamingo emoji',
    }),
    emojiSvg: flamingo,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.squirrel',
      defaultMessage: 'Anonymous Squirrel',
      description: 'The nickname for an anonymous user with a squirrel emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.squirrel-you',
      defaultMessage: 'Anonymous Squirrel (You)',
      description:
        'The nickname for when the current user is anonymous, with a squirrel emoji',
    }),
    emojiSvg: squirrel,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.duck',
      defaultMessage: 'Anonymous Duck',
      description: 'The nickname for an anonymous user with a duck emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.duck-you',
      defaultMessage: 'Anonymous Duck (You)',
      description:
        'The nickname for when the current user is anonymous, with a duck emoji',
    }),
    emojiSvg: duck,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.rhino',
      defaultMessage: 'Anonymous Rhino',
      description: 'The nickname for an anonymous user with a rhino emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.rhino-you',
      defaultMessage: 'Anonymous Rhino (You)',
      description:
        'The nickname for when the current user is anonymous, with a rhino emoji',
    }),
    emojiSvg: rhino,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.seal',
      defaultMessage: 'Anonymous Seal',
      description: 'The nickname for an anonymous user with a seal emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.seal-you',
      defaultMessage: 'Anonymous Seal (You)',
      description:
        'The nickname for when the current user is anonymous, with a seal emoji',
    }),
    emojiSvg: seal,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.camel',
      defaultMessage: 'Anonymous Camel',
      description: 'The nickname for an anonymous user with a camel emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.camel-you',
      defaultMessage: 'Anonymous Camel (You)',
      description:
        'The nickname for when the current user is anonymous, with a camel emoji',
    }),
    emojiSvg: camel,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.shark',
      defaultMessage: 'Anonymous Shark',
      description: 'The nickname for an anonymous user with a shark emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.shark-you',
      defaultMessage: 'Anonymous Shark (You)',
      description:
        'The nickname for when the current user is anonymous, with a shark emoji',
    }),
    emojiSvg: shark,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.hammerhead',
      defaultMessage: 'Anonymous Hammerhead',
      description: 'The nickname for an anonymous user with a shark emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.hammerhead-you',
      defaultMessage: 'Anonymous Hammerhead (You)',
      description:
        'The nickname for when the current user is anonymous, with a shark emoji',
    }),
    emojiSvg: shark,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.llama',
      defaultMessage: 'Anonymous Llama',
      description: 'The nickname for an anonymous user with a llama emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.llama-you',
      defaultMessage: 'Anonymous Llama (You)',
      description:
        'The nickname for when the current user is anonymous, with a llama emoji',
    }),
    emojiSvg: llama,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.alpaca',
      defaultMessage: 'Anonymous Alpaca',
      description: 'The nickname for an anonymous user with a llama emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.alpaca-you',
      defaultMessage: 'Anonymous Alpaca (You)',
      description:
        'The nickname for when the current user is anonymous, with a llama emoji',
    }),
    emojiSvg: llama,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.turtle',
      defaultMessage: 'Anonymous Turtle',
      description: 'The nickname for an anonymous user with a turtle emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.turtle-you',
      defaultMessage: 'Anonymous Turtle (You)',
      description:
        'The nickname for when the current user is anonymous, with a turtle emoji',
    }),
    emojiSvg: turtle,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.tortoise',
      defaultMessage: 'Anonymous Tortoise',
      description: 'The nickname for an anonymous user with a turtle emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.tortoise-you',
      defaultMessage: 'Anonymous Tortoise (You)',
      description:
        'The nickname for when the current user is anonymous, with a turtle emoji',
    }),
    emojiSvg: turtle,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.frog',
      defaultMessage: 'Anonymous Frog',
      description: 'The nickname for an anonymous user with a frog emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.frog-you',
      defaultMessage: 'Anonymous Frog (You)',
      description:
        'The nickname for when the current user is anonymous, with a frog emoji',
    }),
    emojiSvg: frog,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.gorilla',
      defaultMessage: 'Anonymous Gorilla',
      description: 'The nickname for an anonymous user with a gorilla emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.gorilla-you',
      defaultMessage: 'Anonymous Gorilla (You)',
      description:
        'The nickname for when the current user is anonymous, with a gorilla emoji',
    }),
    emojiSvg: gorilla,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.penguin',
      defaultMessage: 'Anonymous Penguin',
      description: 'The nickname for an anonymous user with a penguin emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.penguin-you',
      defaultMessage: 'Anonymous Penguin (You)',
      description:
        'The nickname for when the current user is anonymous, with a penguin emoji',
    }),
    emojiSvg: penguin,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.boar',
      defaultMessage: 'Anonymous Boar',
      description: 'The nickname for an anonymous user with a boar emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.boar-you',
      defaultMessage: 'Anonymous Boar (You)',
      description:
        'The nickname for when the current user is anonymous, with a boar emoji',
    }),
    emojiSvg: boar,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.kangaroo',
      defaultMessage: 'Anonymous Kangaroo',
      description: 'The nickname for an anonymous user with a kangaroo emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.kangaroo-you',
      defaultMessage: 'Anonymous Kangaroo (You)',
      description:
        'The nickname for when the current user is anonymous, with a kangaroo emoji',
    }),
    emojiSvg: kangaroo,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.beaver',
      defaultMessage: 'Anonymous Beaver',
      description: 'The nickname for an anonymous user with a beaver emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.beaver-you',
      defaultMessage: 'Anonymous Beaver (You)',
      description:
        'The nickname for when the current user is anonymous, with a beaver emoji',
    }),
    emojiSvg: beaver,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.turkey',
      defaultMessage: 'Anonymous Turkey',
      description: 'The nickname for an anonymous user with a turkey emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.turkey-you',
      defaultMessage: 'Anonymous Turkey (You)',
      description:
        'The nickname for when the current user is anonymous, with a turkey emoji',
    }),
    emojiSvg: turkey,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.otter',
      defaultMessage: 'Anonymous Otter',
      description: 'The nickname for an anonymous user with an otter emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.otter-you',
      defaultMessage: 'Anonymous Otter (You)',
      description:
        'The nickname for when the current user is anonymous, with an otter emoji',
    }),
    emojiSvg: otter,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.snake',
      defaultMessage: 'Anonymous Snake',
      description: 'The nickname for an anonymous user with a snake emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.snake-you',
      defaultMessage: 'Anonymous Snake (You)',
      description:
        'The nickname for when the current user is anonymous, with a snake emoji',
    }),
    emojiSvg: snake,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.python',
      defaultMessage: 'Anonymous Python',
      description: 'The nickname for an anonymous user with a snake emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.python-you',
      defaultMessage: 'Anonymous Python (You)',
      description:
        'The nickname for when the current user is anonymous, with a snake emoji',
    }),
    emojiSvg: snake,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.cobra',
      defaultMessage: 'Anonymous Cobra',
      description: 'The nickname for an anonymous user with a snake emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.cobra-you',
      defaultMessage: 'Anonymous Cobra (You)',
      description:
        'The nickname for when the current user is anonymous, with a snake emoji',
    }),
    emojiSvg: snake,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.rabbit',
      defaultMessage: 'Anonymous Rabbit',
      description: 'The nickname for an anonymous user with a rabbit emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.rabbit-you',
      defaultMessage: 'Anonymous Rabbit (You)',
      description:
        'The nickname for when the current user is anonymous, with a rabbit emoji',
    }),
    emojiSvg: rabbit,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.bunny',
      defaultMessage: 'Anonymous Bunny',
      description: 'The nickname for an anonymous user with a rabbit emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.bunny-you',
      defaultMessage: 'Anonymous Bunny (You)',
      description:
        'The nickname for when the current user is anonymous, with a rabbit emoji',
    }),
    emojiSvg: rabbit,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.fish',
      defaultMessage: 'Anonymous Fish',
      description: 'The nickname for an anonymous user with a fish emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.fish-you',
      defaultMessage: 'Anonymous Fish (You)',
      description:
        'The nickname for when the current user is anonymous, with a fish emoji',
    }),
    emojiSvg: fish,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.trout',
      defaultMessage: 'Anonymous Trout',
      description: 'The nickname for an anonymous user with a fish emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.trout-you',
      defaultMessage: 'Anonymous Trout (You)',
      description:
        'The nickname for when the current user is anonymous, with a fish emoji',
    }),
    emojiSvg: fish,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.blobfish',
      defaultMessage: 'Anonymous Blobfish',
      description: 'The nickname for an anonymous user with a fish emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.blobfish-you',
      defaultMessage: 'Anonymous Blobfish (You)',
      description:
        'The nickname for when the current user is anonymous, with a fish emoji',
    }),
    emojiSvg: fish,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.cod',
      defaultMessage: 'Anonymous Cod',
      description: 'The nickname for an anonymous user with a fish emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.cod-you',
      defaultMessage: 'Anonymous Cod (You)',
      description:
        'The nickname for when the current user is anonymous, with a fish emoji',
    }),
    emojiSvg: fish,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.crocodile',
      defaultMessage: 'Anonymous Crocodile',
      description: 'The nickname for an anonymous user with a crocodile emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.crocodile-you',
      defaultMessage: 'Anonymous Crocodile (You)',
      description:
        'The nickname for when the current user is anonymous, with a crocodile emoji',
    }),
    emojiSvg: crocodile,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.alligator',
      defaultMessage: 'Anonymous Alligator',
      description: 'The nickname for an anonymous user with a crocodile emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.alligator-you',
      defaultMessage: 'Anonymous Alligator (You)',
      description:
        'The nickname for when the current user is anonymous, with a crocodile emoji',
    }),
    emojiSvg: crocodile,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.dog',
      defaultMessage: 'Anonymous Dog',
      description: 'The nickname for an anonymous user with a dog emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.dog-you',
      defaultMessage: 'Anonymous Dog (You)',
      description:
        'The nickname for when the current user is anonymous, with a dog emoji',
    }),
    emojiSvg: dog,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.puppy',
      defaultMessage: 'Anonymous Puppy',
      description: 'The nickname for an anonymous user with a dog emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.puppy-you',
      defaultMessage: 'Anonymous Puppy (You)',
      description:
        'The nickname for when the current user is anonymous, with a dog emoji',
    }),
    emojiSvg: dog,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.poodle',
      defaultMessage: 'Anonymous Poodle',
      description: 'The nickname for an anonymous user with a poodle emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.poodle-you',
      defaultMessage: 'Anonymous Poodle (You)',
      description:
        'The nickname for when the current user is anonymous, with a poodle emoji',
    }),
    emojiSvg: poodle,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.ox',
      defaultMessage: 'Anonymous Ox',
      description: 'The nickname for an anonymous user with a ox emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.ox-you',
      defaultMessage: 'Anonymous Ox (You)',
      description: 'The nickname for when the current user is anonymous, with a ox emoji',
    }),
    emojiSvg: ox,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.bison',
      defaultMessage: 'Anonymous Bison',
      description: 'The nickname for an anonymous user with a bison emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.bison-you',
      defaultMessage: 'Anonymous Bison (You)',
      description:
        'The nickname for when the current user is anonymous, with a bison emoji',
    }),
    emojiSvg: bison,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.buffalo',
      defaultMessage: 'Anonymous Buffalo',
      description: 'The nickname for an anonymous user with a bison emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.buffalo-you',
      defaultMessage: 'Anonymous Buffalo (You)',
      description:
        'The nickname for when the current user is anonymous, with a bison emoji',
    }),
    emojiSvg: bison,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.giraffe',
      defaultMessage: 'Anonymous Giraffe',
      description: 'The nickname for an anonymous user with a giraffe emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.giraffe-you',
      defaultMessage: 'Anonymous Giraffe (You)',
      description:
        'The nickname for when the current user is anonymous, with a giraffe emoji',
    }),
    emojiSvg: giraffe,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.hippopotamus',
      defaultMessage: 'Anonymous Hippopotamus',
      description: 'The nickname for an anonymous user with a hippopotamus emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.hippopotamus-you',
      defaultMessage: 'Anonymous Hippopotamus (You)',
      description:
        'The nickname for when the current user is anonymous, with a hippopotamus emoji',
    }),
    emojiSvg: hippo,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.badger',
      defaultMessage: 'Anonymous Badger',
      description: 'The nickname for an anonymous user with a badger emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.badger-you',
      defaultMessage: 'Anonymous Badger (You)',
      description:
        'The nickname for when the current user is anonymous, with a badger emoji',
    }),
    emojiSvg: badger,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.peacock',
      defaultMessage: 'Anonymous Peacock',
      description: 'The nickname for an anonymous user with a peacock emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.peacock-you',
      defaultMessage: 'Anonymous Peacock (You)',
      description:
        'The nickname for when the current user is anonymous, with a peacock emoji',
    }),
    emojiSvg: peacock,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.lizard',
      defaultMessage: 'Anonymous Lizard',
      description: 'The nickname for an anonymous user with a lizard emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.lizard-you',
      defaultMessage: 'Anonymous Lizard (You)',
      description:
        'The nickname for when the current user is anonymous, with a lizard emoji',
    }),
    emojiSvg: lizard,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.gecko',
      defaultMessage: 'Anonymous Gecko',
      description: 'The nickname for an anonymous user with a lizard emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.gecko-you',
      defaultMessage: 'Anonymous Gecko (You)',
      description:
        'The nickname for when the current user is anonymous, with a lizard emoji',
    }),
    emojiSvg: lizard,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.chameleon',
      defaultMessage: 'Anonymous Chameleon',
      description: 'The nickname for an anonymous user with a lizard emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.chameleon-you',
      defaultMessage: 'Anonymous Chameleon (You)',
      description:
        'The nickname for when the current user is anonymous, with a lizard emoji',
    }),
    emojiSvg: lizard,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.sunfish',
      defaultMessage: 'Anonymous Sunfish',
      description: 'The nickname for an anonymous user with a tropical fish emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.sunfish-you',
      defaultMessage: 'Anonymous Sunfish (You)',
      description:
        'The nickname for when the current user is anonymous, with a tropical fish emoji',
    }),
    emojiSvg: tropicalFish,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.clownfish',
      defaultMessage: 'Anonymous Clownfish',
      description: 'The nickname for an anonymous user with a tropical fish emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.clownfish-you',
      defaultMessage: 'Anonymous Clownfish (You)',
      description:
        'The nickname for when the current user is anonymous, with a tropical fish emoji',
    }),
    emojiSvg: tropicalFish,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.blowfish',
      defaultMessage: 'Anonymous Blowfish',
      description: 'The nickname for an anonymous user with a blowfish emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.blowfish-you',
      defaultMessage: 'Anonymous Blowfish (You)',
      description:
        'The nickname for when the current user is anonymous, with a blowfish emoji',
    }),
    emojiSvg: blowfish,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.snail',
      defaultMessage: 'Anonymous Snail',
      description: 'The nickname for an anonymous user with a snail emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.snail-you',
      defaultMessage: 'Anonymous Snail (You)',
      description:
        'The nickname for when the current user is anonymous, with a snail emoji',
    }),
    emojiSvg: snail,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.caterpiller',
      defaultMessage: 'Anonymous Caterpiller',
      description: 'The nickname for an anonymous user with a caterpiller emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.caterpiller-you',
      defaultMessage: 'Anonymous Caterpiller (You)',
      description:
        'The nickname for when the current user is anonymous, with a caterpiller emoji',
    }),
    emojiSvg: caterpiller,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.millipede',
      defaultMessage: 'Anonymous Millipede',
      description: 'The nickname for an anonymous user with a caterpiller emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.millipede-you',
      defaultMessage: 'Anonymous Millipede (You)',
      description:
        'The nickname for when the current user is anonymous, with a caterpiller emoji',
    }),
    emojiSvg: caterpiller,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.snowman',
      defaultMessage: 'Anonymous Snowman',
      description: 'The nickname for an anonymous user with a snowman emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.snowman-you',
      defaultMessage: 'Anonymous Snowman (You)',
      description:
        'The nickname for when the current user is anonymous, with a snowman emoji',
    }),
    emojiSvg: snowman,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.lobster',
      defaultMessage: 'Anonymous Lobster',
      description: 'The nickname for an anonymous user with a lobster emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.lobster-you',
      defaultMessage: 'Anonymous Lobster (You)',
      description:
        'The nickname for when the current user is anonymous, with a lobster emoji',
    }),
    emojiSvg: lobster,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.shrimp',
      defaultMessage: 'Anonymous Shrimp',
      description: 'The nickname for an anonymous user with a shrimp emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.shrimp-you',
      defaultMessage: 'Anonymous Shrimp (You)',
      description:
        'The nickname for when the current user is anonymous, with a shrimp emoji',
    }),
    emojiSvg: shrimp,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.oyster',
      defaultMessage: 'Anonymous Oyster',
      description: 'The nickname for an anonymous user with an oyster emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.oyster-you',
      defaultMessage: 'Anonymous Oyster (You)',
      description:
        'The nickname for when the current user is anonymous, with an oyster emoji',
    }),
    emojiSvg: oyster,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.pear',
      defaultMessage: 'Anonymous Pear',
      description: 'The nickname for an anonymous user with a pear emoji, ie the fruit',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.pear-you',
      defaultMessage: 'Anonymous Pear (You)',
      description:
        'The nickname for when the current user is anonymous, with a pear emoji',
    }),
    emojiSvg: pear,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.watermelon',
      defaultMessage: 'Anonymous Watermelon',
      description: 'The nickname for an anonymous user with a watermelon emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.watermelon-you',
      defaultMessage: 'Anonymous Watermelon (You)',
      description:
        'The nickname for when the current user is anonymous, with a watermelon emoji',
    }),
    emojiSvg: watermelon,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.melon',
      defaultMessage: 'Anonymous Melon',
      description: 'The nickname for an anonymous user with a melon emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.melon-you',
      defaultMessage: 'Anonymous Melon (You)',
      description:
        'The nickname for when the current user is anonymous, with a melon emoji',
    }),
    emojiSvg: watermelon,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.coconut',
      defaultMessage: 'Anonymous Coconut',
      description: 'The nickname for an anonymous user with a coconut emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.coconut-you',
      defaultMessage: 'Anonymous Coconut (You)',
      description:
        'The nickname for when the current user is anonymous, with a coconut emoji',
    }),
    emojiSvg: coconut,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.clover',
      defaultMessage: 'Anonymous Clover',
      description: 'The nickname for an anonymous user with a clover emoji: 🍀',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.clover-you',
      defaultMessage: 'Anonymous Clover (You)',
      description:
        'The nickname for when the current user is anonymous, with a clover emoji',
    }),
    emojiSvg: clover,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.grapes',
      defaultMessage: 'Anonymous Grapes',
      description: 'The nickname for an anonymous user with a grapes emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.grapes-you',
      defaultMessage: 'Anonymous Grapes (You)',
      description:
        'The nickname for when the current user is anonymous, with a grapes emoji',
    }),
    emojiSvg: grape,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.strawberry',
      defaultMessage: 'Anonymous Strawberry',
      description: 'The nickname for an anonymous user with a strawberry emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.strawberry-you',
      defaultMessage: 'Anonymous Strawberry (You)',
      description:
        'The nickname for when the current user is anonymous, with a strawberry emoji',
    }),
    emojiSvg: strawberry,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.apple',
      defaultMessage: 'Anonymous Apple',
      description: 'The nickname for an anonymous user with an apple emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.apple-you',
      defaultMessage: 'Anonymous Apple (You)',
      description:
        'The nickname for when the current user is anonymous, with an apple emoji',
    }),
    emojiSvg: apple,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.seedling',
      defaultMessage: 'Anonymous Seedling',
      description: 'The nickname for an anonymous user with a seedling emoji: 🌱',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.seedling-you',
      defaultMessage: 'Anonymous Seedling (You)',
      description:
        'The nickname for when the current user is anonymous, with a seedling emoji',
    }),
    emojiSvg: seedling,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.cactus',
      defaultMessage: 'Anonymous Cactus',
      description: 'The nickname for an anonymous user with a cactus emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.cactus-you',
      defaultMessage: 'Anonymous Cactus (You)',
      description:
        'The nickname for when the current user is anonymous, with a cactus emoji',
    }),
    emojiSvg: cactus,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.lemon',
      defaultMessage: 'Anonymous Lemon',
      description: 'The nickname for an anonymous user with a lemon emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.lemon-you',
      defaultMessage: 'Anonymous Lemon (You)',
      description:
        'The nickname for when the current user is anonymous, with a lemon emoji',
    }),
    emojiSvg: lemon,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.tomato',
      defaultMessage: 'Anonymous Tomato',
      description: 'The nickname for an anonymous user with a tomato emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.tomato-you',
      defaultMessage: 'Anonymous Tomato (You)',
      description:
        'The nickname for when the current user is anonymous, with a tomato emoji',
    }),
    emojiSvg: tomato,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.sunflower',
      defaultMessage: 'Anonymous Sunflower',
      description: 'The nickname for an anonymous user with a sunflower emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.sunflower-you',
      defaultMessage: 'Anonymous Sunflower (You)',
      description:
        'The nickname for when the current user is anonymous, with a sunflower emoji',
    }),
    emojiSvg: sunflower,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.blossom',
      defaultMessage: 'Anonymous Blossom',
      description: 'The nickname for an anonymous user with a blossom emoji: 🌸',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.blossom-you',
      defaultMessage: 'Anonymous Blossom (You)',
      description:
        'The nickname for when the current user is anonymous, with a blossom emoji',
    }),
    emojiSvg: blossom,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.orange',
      defaultMessage: 'Anonymous Orange',
      description:
        'The nickname for an anonymous user with an orange emoji, like the fruit',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.orange-you',
      defaultMessage: 'Anonymous Orange (You)',
      description:
        'The nickname for when the current user is anonymous, with an orange emoji',
    }),
    emojiSvg: orange,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.kiwi',
      defaultMessage: 'Anonymous Kiwi',
      description: 'The nickname for an anonymous user with a kiwi emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.kiwi-you',
      defaultMessage: 'Anonymous Kiwi (You)',
      description:
        'The nickname for when the current user is anonymous, with a kiwi emoji',
    }),
    emojiSvg: kiwi,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.avocado',
      defaultMessage: 'Anonymous Avocado',
      description: 'The nickname for an anonymous user with an avocado emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.avocado-you',
      defaultMessage: 'Anonymous Avocado (You)',
      description:
        'The nickname for when the current user is anonymous, with an avocado emoji',
    }),
    emojiSvg: avocado,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.pineapple',
      defaultMessage: 'Anonymous Pineapple',
      description: 'The nickname for an anonymous user with a pineapple emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.pineapple-you',
      defaultMessage: 'Anonymous Pineapple (You)',
      description:
        'The nickname for when the current user is anonymous, with a pineapple emoji',
    }),
    emojiSvg: pineapple,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.mango',
      defaultMessage: 'Anonymous Mango',
      description: 'The nickname for an anonymous user with a mango emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.mango-you',
      defaultMessage: 'Anonymous Mango (You)',
      description:
        'The nickname for when the current user is anonymous, with a mango emoji',
    }),
    emojiSvg: mango,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.rose',
      defaultMessage: 'Anonymous Rose',
      description: 'The nickname for an anonymous user with a rose emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.rose-you',
      defaultMessage: 'Anonymous Rose (You)',
      description:
        'The nickname for when the current user is anonymous, with a rose emoji',
    }),
    emojiSvg: rose,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.carrot',
      defaultMessage: 'Anonymous Carrot',
      description: 'The nickname for an anonymous user with a carrot emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.carrot-you',
      defaultMessage: 'Anonymous Carrot (You)',
      description:
        'The nickname for when the current user is anonymous, with a carrot emoji',
    }),
    emojiSvg: carrot,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.blueberries',
      defaultMessage: 'Anonymous Blueberries',
      description: 'The nickname for an anonymous user with blueberries as the emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.blueberries-you',
      defaultMessage: 'Anonymous Blueberries (You)',
      description:
        'The nickname for when the current user is anonymous, with bluberries as the emoji',
    }),
    emojiSvg: blueberries,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.chili',
      defaultMessage: 'Anonymous Chili',
      description:
        'The nickname for an anonymous user with a chili (the hot pepper) emoji 🌶️',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.chili-you',
      defaultMessage: 'Anonymous Chili (You)',
      description:
        'The nickname for when the current user is anonymous, with a chili (the hot pepper) emoji 🌶️',
    }),
    emojiSvg: chili,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.cherry',
      defaultMessage: 'Anonymous Cherry',
      description: 'The nickname for an anonymous user with a cherry emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.cherry-you',
      defaultMessage: 'Anonymous Cherry (You)',
      description:
        'The nickname for when the current user is anonymous, with a cherry emoji',
    }),
    emojiSvg: cherry,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.lettuce',
      defaultMessage: 'Anonymous Lettuce',
      description:
        'The nickname for an anonymous user with a lettuce emoji (like the vegetable)',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.lettuce-you',
      defaultMessage: 'Anonymous Lettuce (You)',
      description:
        'The nickname for when the current user is anonymous, with a lettuce emoji (like the vegetable)',
    }),
    emojiSvg: lettuce,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.corn',
      defaultMessage: 'Anonymous Corn',
      description:
        'The nickname for an anonymous user with a corn emoji (like the vegetable)',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.corn-you',
      defaultMessage: 'Anonymous Corn (You)',
      description:
        'The nickname for when the current user is anonymous, with a corn emoji (like the vegetable)',
    }),
    emojiSvg: corn,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.broccoli',
      defaultMessage: 'Anonymous Broccoli',
      description:
        'The nickname for an anonymous user with a broccoli emoji (like the vegetable)',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.broccoli-you',
      defaultMessage: 'Anonymous Broccoli (You)',
      description:
        'The nickname for when the current user is anonymous, with a broccoli emoji (like the vegetable)',
    }),
    emojiSvg: broccoli,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.capsicum',
      defaultMessage: 'Anonymous Capsicum',
      description:
        'The nickname for an anonymous user with a capsicum emoji 🫑, ie a bell pepper',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.capsicum-you',
      defaultMessage: 'Anonymous Capsicum (You)',
      description:
        'The nickname for when the current user is anonymous, with a capsicum emoji 🫑, ie a bell pepper',
    }),
    emojiSvg: capsicum,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.cantaloupe',
      defaultMessage: 'Anonymous Melon',
      description:
        'The nickname for an anonymous user with a melon emoji, like a cantaloupe 🍈',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.cantaloupe-you',
      defaultMessage: 'Anonymous Melon (You)',
      description:
        'The nickname for when the current user is anonymous, with a melon emoji, like a cantaloupe 🍈',
    }),
    emojiSvg: melon,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.olive',
      defaultMessage: 'Anonymous Olive',
      description:
        'The nickname for an anonymous user with an olive emoji 🫒, like the small green fruit (not the color)',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.olive-you',
      defaultMessage: 'Anonymous Olive (You)',
      description:
        'The nickname for when the current user is anonymous, with an olive emoji 🫒, like the small green fruit (not the color)',
    }),
    emojiSvg: olive,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.tree',
      defaultMessage: 'Anonymous Tree',
      description: 'The nickname for an anonymous user with a tree emoji',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.tree-you',
      defaultMessage: 'Anonymous Tree (You)',
      description:
        'The nickname for when the current user is anonymous, with a tree emoji',
    }),
    emojiSvg: tree,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.candy',
      defaultMessage: 'Anonymous Candy',
      description:
        'The nickname for an anonymous user with a candy emoji 🍬 Like a wrapped sweet, not like a lolipop',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.candy-you',
      defaultMessage: 'Anonymous Candy (You)',
      description:
        'The nickname for when the current user is anonymous, with a candy emoji 🍬 Like a wrapped sweet, not like a lolipop',
    }),
    emojiSvg: candy,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.donut',
      defaultMessage: 'Anonymous Donut',
      description: 'The nickname for an anonymous user with a donut emoji 🍩',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.donut-you',
      defaultMessage: 'Anonymous Donut (You)',
      description:
        'The nickname for when the current user is anonymous, with a donut emoji 🍩',
    }),
    emojiSvg: donut,
  },
  {
    collaboratorName: defineMessage({
      id: 'whiteboards.anonymous-names.cookie',
      defaultMessage: 'Anonymous Cookie',
      description: 'The nickname for an anonymous user with a cookie emoji 🍪',
    }),
    yourName: defineMessage({
      id: 'whiteboards.anonymous-names.cookie-you',
      defaultMessage: 'Anonymous Cookie (You)',
      description:
        'The nickname for when the current user is anonymous, with a cookie emoji 🍪',
    }),
    emojiSvg: cookie,
  },
];
